import { Search, Server, MessagesSquare, ShieldCheck, LifeBuoy } from "lucide-react";

// The 5-phase automation delivery workflow. Each phase is colour-coded while
// staying within a cohesive cool-spectrum palette aligned to the brand.
export const PHASES = [
    {
        num: "1",
        colour: "#10B981",
        icon: Search,
        title: "Discovery & Local Infrastructure Audit",
        tagline: "The Blueprint",
        intro: "Before building, map the client's current technical footprint to ensure compatibility.",
        bullets: [
            {
                lead: "Audit Legacy Systems:",
                desc: "Identify if they use on-premise accounting (e.g. AutoCount, SQL Account) or cloud-native suites (e.g. Bukku, Info-Tech).",
            },
            {
                lead: "Define Gateway Endpoints:",
                desc: "Identify where leads enter (Meta, Google Ads) and how payments are collected (toyyibPay, Stripe).",
            },
            {
                lead: "Compliance Baseline:",
                desc: "Ensure client data handling aligns with PDPA guidelines before configuring AI storage.",
            },
        ],
    },
    {
        num: "2",
        colour: "#14B8A6",
        icon: Server,
        title: "Core Middleware & Tunnelling Setup",
        tagline: "The Engine",
        intro: "This is where the tracks are laid for data to flow securely between the cloud and local servers.",
        bullets: [
            {
                lead: "Deploy AcctBridge:",
                desc: "For clients with local on-premise accounting databases, install the outbound-only tunnelling proxy to open a secure channel to the cloud without disrupting their firewall or static IP configuration.",
            },
            {
                lead: "Establish Make.com/Zapier Hubs:",
                desc: "Create the central environments where webhooks are received, parsed, and routed.",
            },
            {
                lead: "CRM Structuring:",
                desc: "Map standard custom fields in Info-Tech or RocketBoard to prepare for incoming marketing and sales data payloads.",
            },
        ],
    },
    {
        num: "3",
        colour: "#06B6D4",
        icon: MessagesSquare,
        title: "AI Configuration & Communication Layer",
        tagline: "The Voice",
        intro: "Here, the intelligence that interacts with customers and employees is trained and connected.",
        bullets: [
            {
                lead: "Omnichannel Hookup:",
                desc: "Connect WhatsApp API platforms (SendHub or CXWizard) to Make.com.",
            },
            {
                lead: "Prompt Engineering & Language Tuning:",
                desc: "Configure the LLM (GPT-5.4-mini) with system prompts that permit colloquial, localised speech (Manglish, Malay, Chinese, English code-switching).",
            },
            {
                lead: "RAG Knowledge Base Ingestion:",
                desc: "For internal HR use cases, ingest company PDFs into secure vector databases (such as Notion AI) so the AI fetches strictly cited internal answers.",
            },
        ],
    },
    {
        num: "4",
        colour: "#3B82F6",
        icon: ShieldCheck,
        title: "Regulatory & Validation Alignment",
        tagline: "The Shield",
        intro: "The workflows are locked down to ensure compliance with strict Malaysian regulatory standards.",
        bullets: [
            {
                lead: "LHDN MyInvois Integration:",
                desc: "Map invoice JSON payloads from the CRM/accounting system to the mandatory LHDN XML structure. Set up the automated API handshake for real-time validation and QR code generation.",
            },
            {
                lead: "Statutory Calculation Automation:",
                desc: "Program the payroll engine (e.g. Financio) to automatically pull biometric time logs and run them against the updated EPF, SOCSO, and EIS statutory tables.",
            },
        ],
    },
    {
        num: "5",
        colour: "#6366F1",
        icon: LifeBuoy,
        title: "Handover, Routing & Go-Live",
        tagline: "The Safety Net",
        intro: "The final step ensures the system handles anomalies gracefully.",
        bullets: [
            {
                lead: "Human-in-the-Loop (HITL) Fallbacks:",
                desc: "Set up sentiment analysis and fallback paths in CXWizard/Respond.io. If a customer becomes frustrated or asks for a refund, the AI instantly pauses and alerts a human agent.",
            },
            {
                lead: "Live Testing & Execution:",
                desc: "Run end-to-end simulations (e.g. fake lead → AI WhatsApp chat → Closed-Won → automated LHDN invoice → AcctBridge sync to local database).",
            },
        ],
    },
];
